export default __webpack_public_path__ + "static/media/accelerate-transparent.171b66a7.png";